/* eslint-disable react/no-array-index-key */
import React from 'react';

import PropTypes from 'prop-types';
import { useMediaQuery, useTheme, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const ListItems = ({ classes, data, size, dash }) => {
  const xsSize = useMediaQuery(useTheme().breakpoints.between('xs', 'sm'));
  return (
    <ul className={classes.dashLi}>
      {data?.slice(0, size).map((item, index) => (
        <li key={index}>
          <Typography variant={xsSize ? 'button' : 'body1'}>
            {dash} {item}
          </Typography>
        </li>
      ))}
    </ul>
  );
};

ListItems.propTypes = {
  classes: PropTypes.object.isRequired,
  dash: PropTypes.string,
  data: PropTypes.array.isRequired,
  size: PropTypes.number.isRequired,
};
ListItems.defaultProps = {
  dash: undefined,
};
const styles = () => ({
  dashLi: props => props.dash
      ? {
          listStyle: 'none',
          marginLeft: '0',
          marginBottom: 0,
          marginTop: 0,
          paddingLeft: '0',
          textTransform: 'capitalize',
        }
      : {
          paddingLeft: '0',
          marginBottom: 0,
          marginTop: 0,
          marginLeft: '16px',
        },
});

export default withStyles(styles)(ListItems);
